import { fiveHundred } from './five-hundred/module.js';
import { pitch } from './pitch/module.js';
import { belote } from './belote/module.js';
import { belot } from './belot/module.js';
import { bridge } from './bridge/module.js';
const modules = new Map();
export function registerGame(mod) {
    modules.set(mod.meta.id, mod);
}
export function getGame(id) {
    const m = modules.get(id);
    if (!m)
        throw new Error(`Unknown game module: ${id}`);
    return m;
}
export function hasGame(id) {
    return modules.has(id);
}
export function listGames() {
    return [...modules.values()];
}
// Built-in game modules.
registerGame(fiveHundred);
registerGame(pitch);
registerGame(belote);
registerGame(belot);
registerGame(bridge);
//# sourceMappingURL=registry.js.map